import { render } from "./FlexGrid.vue?vue&type=template&id=2aa576b0&scoped=true"
import script from "./FlexGrid.vue?vue&type=script&lang=js"
export * from "./FlexGrid.vue?vue&type=script&lang=js"

import "./FlexGrid.vue?vue&type=style&index=0&id=2aa576b0&lang=scss&scoped=true"
import "./FlexGrid.vue?vue&type=style&index=1&id=2aa576b0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa576b0"]])

export default __exports__